import React from 'react'
import SearchErrorMessage from './SearchErrorMessage'
import Spinner from '../../components/Spinner/Spinner'
import type { SearchScreenResultProps } from './types'

function SearchScreenResult({
  children,
  emptyCollectionResponse,
  searchError,
  collectionsReady,
  searchQuery,
}: SearchScreenResultProps) {
  return (
    <div className="search-screen__result">
      <div
        className="search-screen__result-spinner-container"
        style={{
          display: collectionsReady ? 'none' : 'flex',
        }}
      >
        <Spinner visible={!collectionsReady} mini={true} />
      </div>
      <div
        style={{
          display: collectionsReady ? 'block' : 'none',
        }}
      >
        {searchError && (
          <SearchErrorMessage errorMessage="Sorry, there was an unexpected error with search. Please check back later." />
        )}
        {emptyCollectionResponse && !searchError && (
          <SearchErrorMessage
            errorMessage={`We couldn't find any results for "${searchQuery}"`}
          />
        )}
        {children}
      </div>
    </div>
  )
}

export default SearchScreenResult
